import { Drama, Feather, Globe, PersonStanding } from "lucide-react";
import type { LucideIcon } from "lucide-react";
import { useTranslation } from "react-i18next";
import type { InsightKey } from "@/utils/isInsightPresent";

const icons: Record<InsightKey, LucideIcon> = {
  synopsis: Feather,
  characters: PersonStanding,
  worldAndSetting: Globe,
  tropes: Drama,
};

const titleKeys: Record<InsightKey, string> = {
  synopsis: "synopsis.title",
  characters: "characters.title",
  worldAndSetting: "worldAndSettingCard.title",
  tropes: "tropesCard.title",
};

const messageKeys: Record<InsightKey, string> = {
  synopsis: "unavailableInsights.messageSingular",
  characters: "unavailableInsights.messagePlural",
  worldAndSetting: "unavailableInsights.messageSingular",
  tropes: "unavailableInsights.messagePlural",
};

export function UnavailableInsightCard({ insight }: { insight: InsightKey }) {
  const { t } = useTranslation("jobDetails");
  const Icon = icons[insight];
  const name = t(titleKeys[insight]);

  return (
    <div
      className="rounded-[1.5rem] border border-dashed border-secondary-200 bg-white/60 p-6"
      data-testid={`unavailable-${insight}-card`}
    >
      <div className="flex items-center gap-2">
        <Icon className="w-[1.125rem] h-[1.125rem] text-secondary-400" />
        <h2 className="text-lg font-semibold text-secondary-400 leading-7">
          {name}
        </h2>
      </div>
      <p className="mt-3 text-sm text-secondary-400 font-light">
        {t(messageKeys[insight], { insight: name })}
      </p>
    </div>
  );
}
